import { useState, useMemo } from 'react';

import { CtxMenuEventHandler } from 'types/map';

type UseMapContextMenuReturn = {
    handleCtxMenu: CtxMenuEventHandler;
    handleCtxMenuClose: () => void;
    ctxMenuAnchorPositions:
        | {
              top: number;
              left: number;
          }
        | undefined;
    currentGeoID: number | undefined;
};

export const useMapContextMenu = (): UseMapContextMenuReturn => {
    const [currentGeoID, setCurrentGeoID] = useState<number>();

    const [contextMenu, setContextMenu] = useState<{
        mouseX: number;
        mouseY: number;
    } | null>(null);

    const handleCtxMenu: CtxMenuEventHandler = (event, geo) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                      mouseX: event.clientX + 2,
                      mouseY: event.clientY - 6,
                  }
                : null
        );
        setCurrentGeoID(contextMenu === null ? geo.id : undefined);
    };

    const handleCtxMenuClose = (): void => {
        setContextMenu(null);
    };

    const ctxMenuAnchorPositions = useMemo(
        () =>
            contextMenu
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined,
        [contextMenu]
    );

    return {
        handleCtxMenu,
        handleCtxMenuClose,
        ctxMenuAnchorPositions,
        currentGeoID,
    };
};
